module.exports = __webpack_public_path__ + "resources/img/img_cloud_moa5.c4c7a3a8f2711e07805ec2801714b634.png";